import { useState, useEffect, useRef } from 'react';
import { useMapStore } from '@/store/useMapStore';

const ProductPreview = () => {
  const { selectedPalette, palettes } = useMapStore();
  const palette = palettes.find(p => p.id === selectedPalette);
  const [opacity, setOpacity] = useState(1);
  const imgRef = useRef<HTMLImageElement>(null);
  const currentSrcRef = useRef<string>('');

  useEffect(() => {
    if (!palette?.renderImage) return;

    // renderImage is a full URL (from API) or a local path (from fallback)
    const newSrc = palette.renderImage;

    if (newSrc === currentSrcRef.current) return;

    let cancelled = false;
    let timer: ReturnType<typeof setTimeout>;
    const preloader = new Image();
    preloader.onload = () => {
      if (cancelled) return;
      setOpacity(0);
      timer = setTimeout(() => {
        if (cancelled) return;
        if (imgRef.current) imgRef.current.src = newSrc;
        currentSrcRef.current = newSrc;
        setOpacity(1);
      }, 180);
    };
    preloader.src = newSrc;

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [selectedPalette, palette]);

  if (!palette?.renderImage) return null;

  const initialSrc = palette.renderImage;

  return (
    <div
      className="w-full rounded-lg overflow-hidden"
      style={{ backgroundColor: '#F0EBE3' }}
    >
      <img
        ref={imgRef}
        src={currentSrcRef.current || initialSrc}
        alt={`${palette.displayName} product preview`}
        loading="lazy"
        className="w-full"
        style={{
          aspectRatio: '3/4',
          objectFit: 'cover',
          objectPosition: 'center 38%',
          opacity,
          transition: 'opacity 350ms ease-in-out',
        }}
      />
    </div>
  );
};

export default ProductPreview;
